import { boundField } from "../../../../redux/models/reduxModels";
import { InputEnum } from "../../../enums/NormalInputTypeEnum";

export class DataSourceInputFactory {
  getSharepointDatasourceType(metadata: any, boundedFields: boundField[]): InputEnum {
    const inputBoundFields: boundField[] = boundedFields.filter(item => item.name && metadata?.DisplayName && item.name.split(",").some(name => name.trim().toLowerCase() === metadata.DisplayName.trim().toLowerCase()));
    if (inputBoundFields?.length === 1) {
      return this.determineDatasourceType(inputBoundFields[0]);
    }

    return null;
  }

  determineDatasourceType = (boundedField: boundField) => {
    if (boundedField?.displayAsDropdown && boundedField?.multiSelect) {
      return InputEnum.datasourceMultipleDropdown;
    }

    if (boundedField?.displayAsDropdown) {
      return InputEnum.datasourceDropdown;
    }

    if (boundedField?.multiSelect) {
      return InputEnum.datasourceTagPicker;
    }

    return InputEnum.datasourceText;
  };
}
